























import { Component, Vue } from 'vue-property-decorator';
import Logo from '../../assets/logo.svg?inline';
import AzureAuth from '@/plugins/AzureAuth';
import { Action } from 'vuex-class';
import { ActionsKeys, ActionsPayload } from '@/store/types';

@Component({
  components: {
    Logo,
  },
})
export default class WelcomeScreen extends Vue {
  @Action(ActionsKeys.SET_CURRENT_USER) setCurrentUser!: (payload: ActionsPayload['SET_CURRENT_USER']) => void;

  async loginAsPresenter() {
    try {
      const res = await fetch(`${process.env.VUE_APP_API_URL}/auth/login_aad`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: await AzureAuth.getToken(),
        }),
      });
      if (res.status === 200) {
        const { user, token: jwt } = await res.json();
        this.setCurrentUser({
          user: { ...user },
          jwt,
        });
      }
    } catch (e) {
      console.warn(e);
    }
  }
}
